import React, { Fragment, useEffect, useRef, useState } from 'react'
import TableComponent from '../../../component/Table/TableComponent'
import { Button, capitalize, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormHelperText, FormLabel, TableCell, TableRow, Typography } from '@mui/material'
import editIcon from "../../../assets/icons/Edit.svg"
import deleteIcon from "../../../assets/icons/trash.svg"
import CommonButton from '../../../component/button/Button'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import uploadIcon from "../../../assets/icons/upload.svg"
import InputComponent from '../../../component/input/Input'
import { baseURL, StammdatenData, StammdatenInhabarInputData, StammdatenInputData } from '../../../content/content'
import CommonModal from "../../../component/model/ModelComponent";
import { addStammdatenDucument, deleteStammdatenDocument, updateCustomerStammdaten, updateStammdatenDocument } from '../../../services/customer-services/customerStammdatenService'
import Toast from '../../../component/toastify/Index'
import { changeDateFormate } from '../../../helper/changeDateFormate'
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next';
import { getCustomerCompanyDetails } from '../../../services/customer-services/customerCompanyService'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { formatAmount, formatGermanAmount, formatPlainAmount, formatUpdateNumber } from '../../../helper/formatAmount'

const columns = [
    { field: 'year', headerName: 'Year', translationKey: 'stammdaten_year' },
    { field: 'Jahersabschuluss', headerName: 'jahresabschluss', translationKey: 'stammdaten_jahersabschuluss' },
    { field: 'eigenkapital', headerName: 'Eigenkapital', translationKey: 'stammdaten_eigenkapital' },
    { field: 'fremdkapital', headerName: 'Fremdkapital', translationKey: 'stammdaten_fremdkapital' },
    { field: 'anlagevermögen', headerName: 'Anlagevermögen', translationKey: 'stammdaten_anlagevermögen' },
    { field: 'still_reserven', headerName: 'Still Reserven', translationKey: 'stammdaten_still_reserven' },
    { field: 'bilanzsumme', headerName: 'Bilanzsumme', translationKey: 'stammdaten_bilanzsumme' },
    { field: 'gewinn', headerName: 'Gewinn', translationKey: 'stammdaten_gewinn' },
    { field: 'action', headerName: 'Action', translationKey: 'client_list_action' },
];

const columnsTwo = [
    { field: 'id', headerName: 'ID', translationKey: 'stammdaten_id' },
    { field: 'documentName', headerName: 'Document Name', translationKey: 'stammdaten_document_name' },
    { field: 'uploadDate', headerName: 'Upload Date', translationKey: 'stammdaten_upload_date' },
    { field: 'documentLink', headerName: 'Document Link', translationKey: 'stammdaten_document_link' },
    { field: 'action', headerName: 'Action', translationKey: 'client_list_action' },
];

function StammdatenTable({ stammdatenData, setStammdaten, setStammdatenErrors, setPerPage, totalRecords, setPageNo, getAllCustomerStammdaten, pageNo, perPage }) {
    const { t } = useTranslation();
    const fileInputRef = useRef(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({});
    const [editingUserId, setEditingUserId] = useState(null);
    const [stammdatenDocumentId, setStammdatenDocumentId] = useState("")
    const [stammdatenLegalForm, setStammdatenLegalForm] = useState("")
    const [stammdatenDocumentDeleteId, setStammdatenDocumentDeleteId] = useState(null);
    const [debouncedValues, setDebouncedValues] = useState({
        jahresabschluss: '',
        eigenkapital: '',
        fremdkapital: '',
        anlagevermögen: '',
        still_reserven: '',
        bilanzsumme: '',
    });
    const [timer, setTimer] = useState(null);

    const handleButtonClick = () => {
        fileInputRef.current.click();
        setStammdatenDocumentId("");
    };

    const getstammdatenAllLegalForm = async () => {
        const response = await getCustomerCompanyDetails();
        setStammdatenLegalForm(response?.customerCompany?.legalForm)
    }

    useEffect(() => {
        getstammdatenAllLegalForm()
    }, [])

    const handleEdit = (objId, id) => {
        setErrors({});
        setIsModalOpen(true)
        const fieldsToFormat = [
            'jahresabschluss',
            'eigenkapital',
            'fremdkapital',
            'anlagevermögen',
            'still_reserven',
            'bilanzsumme'
        ];
        if (objId) {
            const findStammdatenData = stammdatenData.stammdaten.find((items) => items._id === objId)
            if (findStammdatenData) {
                const formattedData = { ...findStammdatenData };
                const debounced = {};

                fieldsToFormat.forEach((field) => {
                    const value = formattedData[field];

                    if (value === null || value === undefined || value === '') {
                        formattedData[field] = '';
                        debounced[field] = '';
                    } else {
                        // Use value directly if it's already formatted string (e.g., "78.000,00")
                        formattedData[field] = formatUpdateNumber(value);
                        debounced[field] = formatUpdateNumber(value);
                    }
                });

                setFormData(formattedData);
                setDebouncedValues(debounced);
            }
        } else {
            const findStammdatenData = stammdatenData.stammdaten.find((items) => items.id === id)
            setFormData({ ...findStammdatenData });
            setDebouncedValues(findStammdatenData)
        }
    }

    const handleDelete = (objId, id) => {

        if (objId) {
            const findStammdatenData = stammdatenData.stammdaten.filter((items) => items._id !== objId)
            setStammdaten((prevState) => ({
                ...prevState,
                stammdaten: findStammdatenData,
            }));
        } else {
            const findStammdatenData = stammdatenData.stammdaten.filter((items) => items.id !== id)
            setStammdaten((prevState) => ({
                ...prevState,
                stammdaten: findStammdatenData,
            }));
        }
    }

    const handleSave = async () => {
        const fieldsToConvert = [
            'jahresabschluss',
            'eigenkapital',
            'fremdkapital',
            'anlagevermögen',
            'still_reserven',
            'bilanzsumme'
        ];

        const converted = stammdatenData?.stammdaten?.map(item => {
            const newItem = { ...item };

            fieldsToConvert.forEach(field => {
                const value = newItem[field];

                if (value !== null && value !== '' && value !== undefined) {
                    newItem[field] = formatPlainAmount(value);
                } else {
                    newItem[field] = null;
                }
            });

            return newItem;
        });

        const payload = {
            ...stammdatenData,
            stammdaten: converted
        }

        if (!stammdatenValidate()) return;
        const response = await updateCustomerStammdaten(payload);
        if (response?.isSuccess) {
            Toast(response?.message, "success");
            setIsModalOpen(false);
            getAllCustomerStammdaten();
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        if (!validate()) return;
        if (formData._id || formData.id) {
            const newdata = stammdatenData.stammdaten.map((items) => {
                if (items._id == formData._id) {
                    return formData
                } else {
                    return items
                }
            })

            setStammdaten((prevState) => ({
                ...prevState,
                stammdaten: newdata,
            }));

        } else {
            formData.id = Date.now();
            setStammdaten((prevState) => ({
                ...prevState,
                stammdaten: [...prevState.stammdaten || [], formData],
            }));
        }

        setIsModalOpen(false)
        setFormData({});
        setDebouncedValues({
            jahresabschluss: '',
            eigenkapital: '',
            fremdkapital: '',
            anlagevermögen: '',
            still_reserven: '',
            bilanzsumme: '',
        })
    }

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'jahresabschluss' || name === 'eigenkapital' || name === 'fremdkapital' || name === 'anlagevermögen' || name === 'still_reserven' || name === 'bilanzsumme') {
            // Immediately set the raw value in the form state to avoid losing user input while typing
            setFormData((prev) => ({ ...prev, [name]: value }));

            // Clear the previous timer if it's still active
            if (timer) {
                clearTimeout(timer);
            }

            // Set a new timer for debouncing the formatted value update
            const newTimer = setTimeout(() => {
                // Format the value only after the debounce delay
                const formattedValue = formatGermanAmount(value);
                setDebouncedValues((prev) => ({ ...prev, [name]: formattedValue }));  // Update debounced value after the delay
            }, 500); // 500 ms debounce delay

            setTimer(newTimer);
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
        setErrors({ ...errors, [name]: "" });
    };

    useEffect(() => {
        const debounceTime = setTimeout(() => {
            // Update the form state after the debounce delay with the formatted values
            setFormData((prev) => ({
                ...prev,
                jahresabschluss: debouncedValues.jahresabschluss,
                eigenkapital: debouncedValues.eigenkapital,
                fremdkapital: debouncedValues.fremdkapital,
                anlagevermögen: debouncedValues.anlagevermögen,
                still_reserven: debouncedValues.still_reserven,
                bilanzsumme: debouncedValues.bilanzsumme,
            }));
        }, 1000); // 2000 ms debounce delay for saving the formatted value

        return () => clearTimeout(debounceTime);
    }, [debouncedValues]);

    // stammsdaten document 
    const handleDocumentChange = async (e) => {
        const fileInput = e.target;
        const file = fileInput.files[0];

        const formData = new FormData();
        formData.append("document", file);

        try {
            let response;
            if (stammdatenDocumentId) {
                response = await updateStammdatenDocument(stammdatenDocumentId, formData);
            } else {
                response = await addStammdatenDucument(formData);
            }

            if (response?.isSuccess) {
                Toast(response?.message, "success");
                setStammdatenDocumentId(null);
                getAllCustomerStammdaten();
            }

            fileInput.value = '';
        } catch (error) {
            console.error("Error uploading document:", error);
        }
    };

    const validate = () => {
        const newErrors = {};
        let valid = true;
        const disabledYears = stammdatenData?.stammdaten?.map(item => Number(item.year)) || [];
        if (!formData?.year) {
            newErrors.year = `${t('stammdaten_year')} ${t("common_is_required")}`;
            valid = false;
        } else if (formData._id || formData.id) {
            const form_Id_Data = stammdatenData?.stammdaten.find(items => items._id == formData._id);
            const formId_Data = stammdatenData?.stammdaten.find(items => items.id == formData.id);
            if (form_Id_Data.year != Number(formData.year || formId_Data.year != Number(formData.year))) {
                const filtedyear = disabledYears.filter((item => item !== formData.year));
                if (filtedyear?.includes(Number(formData?.year))) {
                    newErrors.year = `${t('stammdaten_valid_year')}`;
                    valid = false;
                }
            } else {
                valid = true;

            }
        } else {
            const filtedyear = disabledYears.filter((item => item !== formData.year));
            if (filtedyear?.includes(Number(formData?.year))) {
                newErrors.year = `${t('stammdaten_valid_year')}`;
                valid = false;
            }
        }

        if (stammdatenLegalForm === "GbR" || stammdatenLegalForm === "Einzelunternehmen") {
            StammdatenInhabarInputData.forEach((item) => {
                if (!formData[item.name] && item.name !== "year") {
                    newErrors[item.name] = `${t(item.translationKey)} ${t("common_is_required")}`
                    valid = false;

                }
            });
        }
        else {
            let count = 0;
            StammdatenInputData.forEach((item) => {
                if (!formData[item.name] && item.name !== "year") {
                    count = count + 1
                    if (count === StammdatenInputData.length - 1) {
                        newErrors.oneField = `${t('stammdaten_is_one_field')} ${t("common_is_required")}`;
                        valid = false;
                    }
                }
            });
        }

        setErrors(newErrors);
        return valid;
    };

    const stammdatenValidate = () => {
        const newErrors = {};
        let valid = true;

        StammdatenData.forEach((item) => {
            const value = stammdatenData[item.name];
            if (!value) {
                newErrors[item.name] = `${t(item.translationKey)} ${t('common_is_required')}`;
                valid = false;
            }
        });

        setStammdatenErrors(newErrors);
        return valid;
    };

    const handleDeleteStammdatenDoucment = async () => {
        const response = await deleteStammdatenDocument(stammdatenDocumentDeleteId)
        if (response?.isSuccess) {
            Toast(response?.message, "success");
            getAllCustomerStammdaten();
            setStammdatenDocumentDeleteId(null)
            handleClose()
        }
    }

    const handleEditClick = (id) => {
        setStammdatenDocumentId(id)
        fileInputRef.current.click();
    };

    const handleYearChange = (newValue, name) => {
        setFormData((prevData) => ({
            ...prevData,
            [name]: newValue?.format('YYYY'),
        }));

        if (!newValue) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: 'Invalid date selected',
            }));
        } else {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: '',
            }));
        }
    };


    const handleClearFormData = () => {
        const formData_id = formData?._id;
        const formDataId = formData?.id;
        if (formData._id) {
            setFormData({ _id: formData_id })
        } else if (formData.id) {
            setFormData({ id: formDataId })
        }
        else {
            setFormData({});
            setDebouncedValues({
                jahresabschluss: '',
                eigenkapital: '',
                fremdkapital: '',
                anlagevermögen: '',
                still_reserven: '',
                bilanzsumme: '',
            })
        }
    }


    // delete  confirme
    const [open, setOpen] = useState(false);

    const handleClickOpen = (id) => {
        id && setStammdatenDocumentDeleteId(id)
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Fragment>
            <div className='stammdaten_tables'>
                <div>
                    <Dialog
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        maxWidth="sm"
                        fullWidth={true}
                        sx={{
                            padding: "20px",
                            "& .MuiDialog-paper": {
                                width: "500px",

                            },
                        }}
                    >
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description" sx={{ fontFamily: "poppins", textAlign: 'center', paddingTop: '10px' }}>
                                <ErrorOutlineIcon sx={{
                                    fontSize: "5rem",
                                    color: '#FFDB8C',
                                    margin: "5px"
                                }} />
                            </DialogContentText>
                            <DialogTitle className='text-center' sx={{ fontWeight: 500, fontFamily: "poppins", fontSize: '25px', paddingBottom: "4px" }}>{t('stammdaten_is_are_you_sure')}</DialogTitle>
                            <DialogContentText id="alert-dialog-description" className='text-center' sx={{ fontFamily: "poppins" }}>
                                {t('stammdaten_is_text_revert')}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions className='stammdaten-confirm-btn' sx={{
                            display: {
                                xs: 'block',
                                sm: "flex"
                            }, justifyContent: "center", items: "center", paddingTop: "1rem", paddingBottom: "2.5rem"
                        }}>
                            <CommonButton text={t('stammdaten_text_delete')} className="stammdaten-action-btn" onClick={() => handleDeleteStammdatenDoucment()} />
                            <CommonButton text={t('payment_status_cancel')} className="stammdaten-action-btn" onClick={handleClose} bgColor="linear-gradient(90deg, #E14A4A 0%, #FF4848 100%);" />
                        </DialogActions>
                    </Dialog>
                </div>

                <CommonModal
                    open={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    title={formData._id || formData.id ? t('stammdaten_edit') : t('stammdaten_add')}
                    className=" stammdaten-model"
                >
                    <Typography
                        className="user-model"
                        sx={{
                            border: "1px solid #E3E3E3",
                            padding: "20px",
                            borderRadius: "10px",
                        }}
                    >
                        <form onSubmit={handleSubmit} className="user-form">
                            <div className="stammdatet-form-overflow">
                                {stammdatenLegalForm === "GbR" || stammdatenLegalForm === "Einzelunternehmen"

                                    ? StammdatenInhabarInputData.map((item) =>
                                        item.type === "select" ? (
                                            <div key={item.name}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <FormLabel
                                                        className="label"
                                                        sx={{
                                                            paddingTop: "1.25rem",
                                                            paddingBottom: "10px",
                                                            display: "inline-block",
                                                            color: "#000",
                                                        }}
                                                    >
                                                        {item.label}
                                                    </FormLabel>
                                                    <DatePicker
                                                        className="stammdaten-year-picker"
                                                        value={
                                                            formData["year"] &&
                                                            dayjs(String(formData["year"]), "YYYY")
                                                        }
                                                        onChange={(newValue) =>
                                                            handleYearChange(newValue, item.name)
                                                        }
                                                        shouldDisableYear={(year) => {
                                                            const disabledYears =
                                                                stammdatenData?.stammdaten?.map(
                                                                    (item) => Number(item.year)
                                                                );
                                                            return disabledYears?.includes(year?.year());
                                                        }}

                                                        slotProps={{
                                                            textField: {
                                                                name: item.name,
                                                                error: !!errors[item.name],
                                                                helperText: errors[item.name] || "",
                                                                InputLabelProps: { shrink: false },
                                                                label: "",
                                                                variant: "outlined",
                                                                placeholder: t('stammdaten_placeholder_year'),
                                                                inputProps: {
                                                                    placeholder: t('stammdaten_placeholder_year'),
                                                                },
                                                                FormHelperTextProps: {
                                                                    sx: {
                                                                        color: "#d32f2f",
                                                                        margin: "5px 0 0 0",
                                                                        fontSize: "14px",
                                                                        fontFamily: "Poppins",
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                        openTo="year"
                                                        views={["year"]}
                                                        sx={{
                                                            width: "100%",
                                                            padding: 0,
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </div>
                                        ) : (
                                            <InputComponent
                                                key={item.name}
                                                borderColor="#E3E3E3"
                                                border="2px solid #E3E3E3"
                                                bordersize="1"
                                                padding="10px 12px"
                                                placeholder={t(item.placeholderTranslationKey)}
                                                label={t(item.translationKey)}
                                                type={item.type}
                                                className="user-input"
                                                name={item?.name}
                                                error={!!errors[item.name]}
                                                helperText={errors[item.name]}
                                                value={formData[item?.name] || ""}
                                                onChange={handleChange}

                                            />
                                        )

                                    )

                                    : StammdatenInputData.map((item) =>
                                        item.type === "select" ? (
                                            <div key={item.name}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <FormLabel
                                                        className="label"
                                                        sx={{
                                                            paddingTop: "1.25rem",
                                                            paddingBottom: "10px",
                                                            display: "inline-block",
                                                            color: "#000",
                                                        }}
                                                    >
                                                        {item.label}
                                                    </FormLabel>
                                                    <DatePicker
                                                        className="stammdaten-year-picker"
                                                        value={
                                                            formData["year"] &&
                                                            dayjs(String(formData["year"]), "YYYY")
                                                        }
                                                        onChange={(newValue) =>
                                                            handleYearChange(newValue, item.name)
                                                        }
                                                        shouldDisableYear={(year) => {
                                                            const disabledYears =
                                                                stammdatenData?.stammdaten?.map(
                                                                    (item) => Number(item.year)
                                                                );
                                                            return disabledYears?.includes(year?.year());
                                                        }}
                                                        slotProps={{
                                                            textField: {
                                                                name: item.name,
                                                                error: !!errors[item.name],
                                                                helperText: errors[item.name] || "",
                                                                InputLabelProps: { shrink: false },
                                                                label: "",
                                                                variant: "outlined",
                                                                placeholder: t('stammdaten_placeholder_year'),
                                                                inputProps: {
                                                                    placeholder: t('stammdaten_placeholder_year'),
                                                                },
                                                                FormHelperTextProps: {
                                                                    sx: {
                                                                        color: "#d32f2f",
                                                                        margin: "5px 0 0 0",
                                                                        fontSize: "14px",
                                                                        fontFamily: "Poppins",
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                        openTo="year"
                                                        views={["year"]}
                                                        sx={{
                                                            width: "100%",
                                                            padding: 0,
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </div>
                                        ) : (
                                            <Fragment>
                                                <InputComponent
                                                    key={item.name}
                                                    borderColor="#E3E3E3"
                                                    border="2px solid #E3E3E3"
                                                    bordersize="1"
                                                    padding="10px 12px"
                                                    type={item.type}
                                                    placeholder={t(item.placeholderTranslationKey)}
                                                    label={t(item.translationKey)}
                                                    className="user-input"
                                                    name={item?.name}
                                                    error={!!errors[item.name]}
                                                    helperText={errors[item.name]}
                                                    value={formData[item?.name] || ""}
                                                    onChange={handleChange}
                                                />
                                            </Fragment>
                                        )
                                    )}
                                {
                                    errors.oneField && (
                                        <FormHelperText
                                            sx={{
                                                color: "#d32f2f",
                                                margin: "5px 0 0 0 ",
                                                fontSize: "14px",
                                                fontFamily: "Poppins"
                                            }}
                                        >
                                            {errors.oneField}
                                        </FormHelperText>
                                    )
                                }
                            </div>

                            <Typography className="model-action-btn">
                                {!editingUserId && (
                                    <CommonButton
                                        text={t('user_clear_all')}
                                        className="invitation-btn button-border-radius"
                                        bgColor="linear-gradient(90deg, #E14A4A 0%, #FF4848 100%);"
                                        onClick={handleClearFormData}
                                    />
                                )}
                                <CommonButton
                                    type="submit"
                                    text={t('stammdaten_save')}
                                    className="add-user-btn button-border-radius"
                                />
                            </Typography>
                        </form>
                    </Typography>
                </CommonModal>

                <div>
                    <div className="stammdaten_add-btn">
                        <CommonButton
                            text={t('stammdaten_add')}
                            className="stammdaten-add-btn-text"
                            icon={<AddCircleOutlineIcon />}
                            onClick={() => {
                                setIsModalOpen(true)
                                setFormData({})
                                setDebouncedValues({
                                    jahresabschluss: '',
                                    eigenkapital: '',
                                    fremdkapital: '',
                                    anlagevermögen: '',
                                    still_reserven: '',
                                    bilanzsumme: '',
                                })
                                setErrors({})
                            }}
                        />
                    </div>

                    <TableComponent
                        data={stammdatenData.stammdaten || []}
                        setPageNo={setPageNo}
                        pageNo={pageNo}
                        perPage={perPage}
                        setPerPage={setPerPage}
                        totalRecords={totalRecords}
                        columns={columns}
                    >
                        {stammdatenData.stammdaten?.map((row, rowIndex) => (
                            <TableRow key={rowIndex}>
                                <TableCell>{row?.year ? row?.year : "-"}</TableCell>
                                <TableCell>{row.jahresabschluss ? formatAmount(row.jahresabschluss) : "0,00"} €</TableCell>
                                <TableCell>{row.eigenkapital ? formatAmount(row.eigenkapital) : "0,00"} €</TableCell>
                                <TableCell>{row.fremdkapital ? formatAmount(row.fremdkapital) : "0,00"} €</TableCell>
                                <TableCell>{row.anlagevermögen ? formatAmount(row.anlagevermögen) : "0,00"} €</TableCell>
                                <TableCell>{row.still_reserven ? formatAmount(row.still_reserven) : "0,00"} €</TableCell>
                                <TableCell>{row.bilanzsumme ? formatAmount(row.bilanzsumme) : "0,00"} €</TableCell>
                                <TableCell>{row.gewinn ? formatAmount(row.gewinn) : "0,00"} €</TableCell>
                                <TableCell>
                                    <Typography
                                        className="action"
                                        classes="flex"
                                        alignItems={"center"}
                                        display={"flex"}
                                    >
                                        <span onClick={() => handleEdit(row?._id, row?.id)}>
                                            <img
                                                src={editIcon}
                                                alt="edit icon"
                                                className="edit-icon"
                                            />
                                        </span>
                                        <span onClick={() => handleDelete(row._id, row?.id)}
                                        >
                                            <img src={deleteIcon} alt="delete icon" />
                                        </span>

                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableComponent>

                    <div className="speichern-btn flex justify-center">
                        <CommonButton
                            text={t('stammdaten_speichern')}
                            onClick={handleSave}
                            className="stammdaten-save-btn"
                        />
                    </div>
                    <hr />
                </div>


                <div>
                    <div className="stammdaten_add-btn stammdaten_file-upload-btn">
                        <CommonButton
                            text={t('stammdaten_upload_document')}
                            onClick={handleButtonClick} className="file-upload-btn"
                            icon={<img src={uploadIcon} className='upload-icon' ></img>}
                        />
                        <input
                            type="file"
                            name='document'
                            ref={fileInputRef}
                            onChange={handleDocumentChange}
                            style={{ display: "none" }}  // Hide the file input
                        />
                    </div>

                    <TableComponent
                        data={stammdatenData.stammdatenDocument}
                        setPageNo={setPageNo}
                        pageNo={pageNo}
                        perPage={perPage}
                        setPerPage={setPerPage}
                        totalRecords={totalRecords}
                        columns={columnsTwo}
                    >
                        {stammdatenData.stammdatenDocument?.map((row, rowIndex) => (
                            <TableRow key={rowIndex} className='stammdaten_table_two'>
                                <TableCell>{rowIndex + 1}</TableCell>
                                <TableCell>{row.document_name}</TableCell>
                                <TableCell> {changeDateFormate(row.upload_date)}</TableCell>
                                <TableCell>  <a href={`${baseURL}/company/stammdaten/${row.document}`} target='_blank' className="document-link">{row.document} </a> </TableCell>
                                <TableCell>
                                    <Typography
                                        className="action"
                                        classes="flex"
                                        alignItems={"center"}
                                        display={"flex"}
                                    >
                                        <span onClick={() => handleEditClick(row._id)}>
                                            <img
                                                src={editIcon}
                                                alt="edit icon"
                                                className="edit-icon"
                                            />
                                        </span>
                                        <span onClick={() => handleClickOpen(row._id)}>
                                            <img src={deleteIcon} alt="delete icon" />
                                        </span>
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableComponent>
                </div>

            </div>
        </Fragment>



    )
}

export default StammdatenTable
